import { createModel } from '@rematch/core';
import { RootModel } from '../root';
import reducers from './notifications.reducers';
import effects from './notifications.effects';
import { NotificationsState } from './notifications.model';

const initialState: NotificationsState = {
  items: []
};

const model = createModel<RootModel>()({
  state: initialState,
  reducers,
  effects
});

export default model;
